import { overviewLayoutVersion } from 'containers/OverviewPage/components/OverviewPage/legacy/legacyConfig';
import { getColumnDefaults } from 'data/transactions/config';
import { List, Map } from 'immutable';

const defaultACMEPreferences = {
  transactionRegister: {
    editDownloaded: true,
    deleteDownloaded: true, // this comes with lots of warnings, so right now default on
    autoSave: true,
    splitsInDialog: false,
    autoSearch: false,
    longCats: false,
    continuousCreate: false,
    showCurrencySymbol: false,
    wrapText: false,
    showAccountColors: false,
    currencySymbol: '$',
    registerComfort: 'comfortable',
    regFieldsSort: {
      cashFlow: List(getColumnDefaults()),
      investment: List(getColumnDefaults('investment')),
    },
  },
  calendarTransaction: {
    showTransactions: false,
    showScheduleTransactions: false,
    showDailyBalances: false,
    exceedingAmount: null,
    accountsToShow: null,
  },
  accountsPrefs: null,
  accountDrawerDefaultOpen: true,
  accountNodePrefs: new Map({}),
  hideIgnoredIncome: true,
  hideIgnoredBills: true,
  hideIgnoredSubscriptions: true,
  hideIgnoredTransfers: true,
  hideIgnoredGoals: true,
  projectedOpen: true,
  setupStateIndex: null,
  completedGSF: false,

  overviewPageLayout: List(),
  overviewPageLayoutVersion: overviewLayoutVersion,
  swlOrder: 'BY_DATE',
  dateRangeProjectedBalances: 'thirty',
  qCardsOffByDefault: null,
  autoRefresh: true,
  kioskmode: false,
  upcomingOpen: true,

  spendingPlanSetupCompleted: false,
  watchlistSetupCompleted: false,

  currencySymbol: '$',
  theme: null,
  hidePlanned: false,
  createCategoryRules: false,
  createPayeeRules: false,
};

const defaultQUICKENPreferences = {
  transactionRegister: {
    editDownloaded: true,
    deleteDownloaded: true, // this comes with lots of warnings, so right now default on
    autoSave: true,
    splitsInDialog: false,
    autoSearch: false,
    longCats: false,
    continuousCreate: false,
    showCurrencySymbol: false,
    wrapText: false,
    showAccountColors: false,
    currencySymbol: '$',
    registerComfort: 'normal',
    regFieldsSort: {
      cashFlow: List(getColumnDefaults()),
      credit: List(getColumnDefaults('credit')),
    },
  },

  calendarTransaction: {
    showTransactions: true,
    showScheduleTransactions: true,
    showDailyBalances: true,
    exceedingAmount: null,
    accountsToShow: null,
  },

  accountsPrefs: null,
  accountDrawerDefaultOpen: true,
  accountNodePrefs: new Map({}),
  projectedOpen: false,
  upcomingOpen: true,

  overviewPageLayout: List(),
  qCardsOffByDefault: null,
  autoRefresh: true,
  kioskmode: false,
  dateRangeProjectedBalances: 'thirty',
  currencySymbol: '$',
  theme: null,
};

export const defaultDatasetPreferences =
  process.env.PROJECT === 'acme' ? defaultACMEPreferences : defaultQUICKENPreferences;
export const defaultUserPreferences = {
  webApp: {
    windowsReviewedWarningEnabled: true,
  },
};

export function regFieldsSortType(regFieldsSort, rawType) {
  const insvestmentTypes = ['INVESTMENT', 'BROKERAGE', 'RETIREMENT', 'OTHER_INVESTMENT'];
  const type = insvestmentTypes.includes(rawType) ? 'investment' : rawType.toLowerCase();
  if (regFieldsSort && type in regFieldsSort) {
    return type;
  }
  return 'cashFlow';
}
